import { Injectable, } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { StoresDataService } from './stores.data.service';


@Injectable()
export class EditableShopResolver implements Resolve<boolean> {
  constructor(
    private router: Router,
    public dataService: StoresDataService
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
  ): Observable<any> {

    return this.dataService.getById(route.parent.params['id'])
        .pipe(catchError(() => this.router.navigateByUrl('/')));
  }
}
